import { useContext } from 'react';
import ServerContext from '../../../contexts/serverContext';

export default function isWebviewCheck() {
    const serverContext = useContext(ServerContext);
    return serverContext.webview === 'true';
}
